import { render, staticRenderFns } from "./my-tuiguang.vue?vue&type=template&id=06a2cd4b&scoped=true&"
import script from "./my-tuiguang.vue?vue&type=script&lang=js&"
export * from "./my-tuiguang.vue?vue&type=script&lang=js&"
import style0 from "./my-tuiguang.vue?vue&type=style&index=0&id=06a2cd4b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06a2cd4b",
  null
  
)

export default component.exports